// BUG-2 (2026-10-04): fail-safe API base resolution.
// A prod build without VITE_API_URL previously fell back to a hardcoded dev
// base, baking it into the shipped bundle (v1.0.33, 2026-10-04) and breaking
// every client call on vecindus.com.
// Correct resolution order:
//   - VITE_API_URL set    -> that value wins (trimmed, trailing slashes stripped).
//   - dev server (DEV)    -> same hostname as the dev page, port 3002 (the
//                            vite dev-server proxy target). Composed at
//                            runtime so the dev host string can never leak
//                            into any emitted bundle or sourcemap.
//   - prod build, no env  -> same-origin RELATIVE '/api' (nginx routes /api).
// Paired with the failOnLocalhostApiBase() guard in vite.config.ts, a missing
// VITE_API_URL can never again hardcode a broken base into a prod bundle.
export function resolveApiBase(): string {
  const envUrl = (import.meta as any).env?.VITE_API_URL;
  if (typeof envUrl === 'string' && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/+$/, '');
  }
  if (import.meta.env.DEV) {
    return `${location.protocol}//${location.hostname}:3002/api`;
  }
  return '/api';
}
